
<template>
  <div class="main_empty"
       v-show="propJson.isShow">
    <div class="shadow"
         @click="toHideGif()"></div>
    <div class="toast">
      <audio :src="src"
             ref="wing"></audio>
      <lottie :options="defaultOptions"
              :height="height"
              :width="width"
              @animCreated="handleAnimation" />
      <span class="info">+{{propJson.price}} <span class="fn2">金币</span></span>
    </div>
  </div>
</template>

<script>
import Lottie from './lottie';
import animationData from '../assets/lottie-4' // 引入json文件
export default {
  props: ['propJson'],
  components: {
    Lottie
  },
  data () {
    return {
      src: require('@/assets/js/gold_music.mp3'),
      height: 90,
      width: 90,
      isShow: false,
      thumb_animation: false,
      defaultOptions: {
        animationData: animationData,
        autoplay: false,//是否自动播放
        loop: false//不循环
      },
      failAudio: {},
      animationSpeed: 2,
      anim: {},
    }
  },
  mounted () {
    this.$nextTick(function () {
      // 获取音频dome，并且执行一次
      this.failAudio = this.$refs.wing
    })
  },
  methods: {
    toHideGif () {
      this.$emit('toHideGif')
    },
    handleAnimation (anim) {
      this.anim = anim;
      this.anim.setSpeed(0.84)
      console.log(this.anim)
      let _this = this;
      // setTimeout(() => {
      //   _this.$emit('toHideGif')
      // }, 2000)
    },
  }
}
</script>
<style scoped>
.main_empty {
  width: 100%;
  height: 100%;
}

.shadow {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.4;
}
.info {
  font-size: 0.24rem;
  font-family: PingFangSC;
  font-weight: 500;
  color: #ff6d37;
}
.fn2 {
  font-size: 0.2rem;
  position: relative;
  top: -0.02rem;
  left: -0.04rem;
}
.toast {
  text-align: center;
  padding-top: 0.22rem;
  background: url("../assets/img/vipActive/coins_gif.png") no-repeat center
    center;
  background-size: 100% 100%;
  width: 1.7rem;
  height: 1.7rem;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>